import styled from 'styled-components'

import { DistributeTableCurrencyCell } from './distribute-table-currency-cell'
import { DistributeTableCurrencyProgress } from './distribute-table-currency-progress'
import { DistributeTableStackedCell } from './distribute-table-stacked-cell'

import type {
  DistributeRowVariant,
  DistributeTableColumn,
} from '../../atoms/reatom-distribute-table'
import type { PairPerformance } from '../../model'
import type { Column } from '@root/shared/ui-kit'

export const distributeTableColumns = (
  rowVariant: DistributeRowVariant,
): Array<
  Column<
    PairPerformance,
    DistributeTableColumn,
    {
      refresh: () => void
    }
  >
> => {
  if (rowVariant === 'stacked') {
    return [
      {
        id: 'currency',
        header: ({ t }) => t('token'),
        render: ({ value }) => <DistributeTableStackedCell value={value} />,
        minWidth: 300,
        justify: 'stretch',
      },
    ]
  }

  return [
    {
      id: 'currency',
      header: ({ t }) => t('token'),
      render: ({ value }) => <DistributeTableCurrencyCell value={value} />,
      minWidth: 400,
    },
    {
      id: 'realized',
      header: ({ t }) => t('common.realized'),
      render: ({ value }) => (
        <DistributeTableCurrencyProgress value={value} placement="bottom" />
      ),
      minWidth: 140,
      justify: 'stretch',
    },
  ]
}

export const TextCell = styled.div`
  color: var(--text-11);

  font-size: 12px;
  font-weight: 500;
  line-height: 16px;

  &[data-trend='up'] {
    color: var(--up-9);
  }
  &[data-trend='down'] {
    color: var(--down-9);
  }
`
